<ng-container *ngIf="!!get">
    <tt-card ttHeading="h_info" ttTranslateHeading>
        <tt-search
            *ngIf="get.comp_keyno === '0'"
            ttLabel="product_search"
            [(ttModel)]="get.product_search"
            [ttSearch]="searchProducts"
            (ttOnSelected)="onProductSelected($event)"
            (ttOnClear)="onProductSelected()"
        >
            <tt-form-field-button buttons ttIcon="far fa-plus" ttGoto="productcreate" [ttGotoParms]="{ argtype: 'prod_keyno', argvalue: get.prod_keyno }"></tt-form-field-button>
        </tt-search>
        <tt-input ttLabel="comp_is_prod_id" [ttModel]="get.comp_is_prod_id" ttReadonly>
            <tt-form-field-button *ngIf="get.comp_is_prod_id > ''" buttons ttIcon="far fa-chevron-right" ttGoto="product" [ttGotoParms]="{ prod_id: get.comp_is_prod_id }"></tt-form-field-button>
        </tt-input>
        <tt-input ttLabel="comp_prod_name" [ttModel]="get.comp_prod_name" ttReadonly></tt-input>
        <tt-input-number ttLabel="quantity_component" [(ttModel)]="get.quantity" ttTextAlign="right" ttFormatNumber ttDecimals="4"></tt-input-number>
        <tt-input-number ttLabel="comp_lineno" [(ttModel)]="get.comp_lineno" ttTextAlign="right" ttFormatNumber></tt-input-number>
        <tt-input *ngIf="get.stock_unit_no === ''" ttLabel="stock_unit" [ttModel]="get.stock_unit_no" ttReadonly></tt-input>
        <tt-select *ngIf="get.stock_unit_no > ''" ttLabel="stock_unit" [ttModel]="get.stock_unit_no" [ttData]="productUnits" ttDataId="unit_no" ttDataName="shortname" ttReadonly></tt-select>
        <tt-input-number ttLabel="comp_waste_pst" [(ttModel)]="get.comp_waste_pst" ttTextAlign="right" ttFormatNumber></tt-input-number>
        <tt-checkbox ttLabel="choicevalidation" [(ttModel)]="get.choicevalidation"></tt-checkbox>
        <tt-textarea ttLabel="note" [(ttModel)]="get.note"></tt-textarea>
        <tt-input *ngIf="get.show_replaceable_comp_choice_prod_id_2 === '1'" ttLabel="replaceable_comp_choice_prod_id_2" [ttModel]="get.replaceable_comp_choice_prod_id_2" ttReadonly>
            <tt-form-field-button buttons ttIcon="far fa-chevron-right" ttGoto="componentreplaceables" [ttGotoParms]="{ comp_keyno: get.comp_keyno }"></tt-form-field-button>
        </tt-input>
        <hr class="col-xs-12 sp-0 k-hr" />

        <tt-button-save ttText="save" (ttClick)="save()" [ttLoading]="saving" ttTextAlign="center"></tt-button-save>
        <tt-button *ngIf="get.comp_keyno > '0'" ttText="delete" (ttClick)="deleteComponent()" ttIcon="far fa-trash-alt" ttType="danger" [ttLoading]="deleting" ttTextAlign="center"></tt-button>
        <tt-button-settings *ngIf="get.show_setting === '1'" ttWebpageName="component"></tt-button-settings>
        <tt-button-goto
            *ngIf="+get.comp_keyno > 0"
            ttText="component_compvalidationset"
            [ttBadge]="get.nbr_of_compvalidation"
            ttGoto="compvalidationset"
            [ttGotoParms]="{ comp_keyno: get.comp_keyno }"
        ></tt-button-goto>
    </tt-card>

    <tt-card *ngIf="get.show_special_fields === '1'" [ttHeading]="get.sublabel_helpcalc" ttTranslateHeading>
        <tt-component-calculation [(get)]="get" [productUnits]="productUnits"></tt-component-calculation>
    </tt-card>

    <tt-card ttHeading="documents" ttTranslateHeading>
        <tt-image *ngIf="get.url_picture > ''" ttLabel="picture" ttLabelView="top" [ttSrc]="get.url_picture"></tt-image>
        <tt-button-goto ttText="picturebanks" ttGoto="picturebanks" [ttGotoParms]="{ argtype: 'prod_id', argvalue: get.comp_is_prod_id }"></tt-button-goto>
        <hr class="col-xs-12 sp-0 k-hr" />
        <tt-list [ttData]="documents" ttShowFileExtensionIcon></tt-list>
    </tt-card>
</ng-container>
